import { Header3, Paragraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ZalogDisclaimer.css';

export const ZalogDisclaimer = () => {
  return (
    <div className={styles['outer']}>
      <div className={styles['inner']}>
        <Header3>Залоговая недвижимость</Header3>
        <Paragraph1>Объект продаётся банком, которому не&nbsp;вернул кредит заёмщик — бывший собственник</Paragraph1>
      </div>
    </div>
  );
};
